import { ModalStoreContext } from '#pplx/frontend/aether/modals/internal/ModalStoreContext.js';
import { assertDefined } from '#pplx/frontend/common/type_utils/assertDefined.js';
import { useContext } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
const ASSERTION_ERR = 'ModalStoreContext must be used within a ModalStoreProvider';
export const useModalStore = (selector) => {
    const ctx = useContext(ModalStoreContext);
    assertDefined(ctx, ASSERTION_ERR);
    return useStore(ctx, useShallow(selector));
};
//# sourceMappingURL=useModalStore.js.map